import React, { FunctionComponent, useCallback, useMemo } from "react"
import { useHistory, useRouteMatch } from "react-router"
import { Link } from "react-router-dom"
import DotButton from "../../components/Buttons/DotButton"
import { eImageVersions /* iImageVersions */ } from "../../definitions/Image"
import { useImage } from "../../hooks/useImage"
import { useImageUrl } from "../../hooks/useImageUrl"
import { useSelector } from "../../store"
import { getArtPieceRoutes } from "./inspector/routes"

interface iProps {
  cover?: string
  title: string
  handleSubmit?: () => void
  handleDelete?: () => void
  submitDeleteText: string
  submitText: string
  isLoading?: boolean
  artPieceType?: string
  type?: "create" | "edit"
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  access?: any
  published?: boolean
}

const ArtPieceHeader: FunctionComponent<iProps> = ({
  title,
  published,
  handleSubmit,
  handleDelete,
  submitDeleteText,
  submitText,
  isLoading = false,
  artPieceType,
  type = "edit",
  access,
  cover,
}) => {
  const history = useHistory()
  const match = useRouteMatch()
  const { user } = useSelector(({ user }) => ({
    user,
  }))

  const { permissions } = user

  const navRoutes = useMemo(
    () =>
      getArtPieceRoutes({
        urlPrefix: match.url,
        access,
        user,
        permissions,
        type: artPieceType,
      }),
    [match.url, artPieceType],
  )

  const handleHisoryBack = useCallback((e: React.SyntheticEvent) => {
    e.preventDefault()
    history.goBack()
  }, [])

  const { file } = useImage({
    fileId: cover,
    fileCollection: "Files_ArtPiecesPreview",
  })

  const coverImage =
    file && useImageUrl(eImageVersions.XLWRegular, file.versions)

  return (
    <div className="inspector-header">
      <div className="inspector-cover-wrap">
        <div
          className="inspector-cover"
          style={{ backgroundImage: `url(${coverImage})` }}
        ></div>
        <div className="inspector-cover-overlay">
          <div className="inspector-headline">
            <Link to={"#"} onClick={handleHisoryBack}>
              <i className="fa fa-chevron-left"></i>
              <span>Back</span>
            </Link>

            <div className="d-flex">
              {access && access.canDelete && (
                <DotButton
                  isLoading={isLoading}
                  className={`btn-red submit-button`}
                  text={submitDeleteText}
                  onClick={handleDelete}
                  type="button"
                >
                  {submitDeleteText}
                </DotButton>
              )}
              {(type === "create" || (access && access.canEdit)) && (
                <DotButton
                  className={`btn-blue submit-button`}
                  text={submitText}
                  isLoading={isLoading}
                  onClick={handleSubmit}
                  type="button"
                >
                  {submitText}
                </DotButton>
              )}
            </div>
          </div>
          <h1 className="inspector-title">{title}</h1>
        </div>
      </div>
      {published !== undefined ? (
        published ? (
          <div className="published">This Art Piece is published!</div>
        ) : (
          <div className="draft">This Art Piece is a draft!</div>
        )
      ) : null}
      <div className="inspector-navigation">
        <ul>
          {navRoutes.map((n, i) => (
            <li
              key={i}
              className={history.location.pathname === n.route ? "active" : ""}
            >
              <Link to={n.route} replace>
                {n.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default ArtPieceHeader
